import { component } from 'picoapp'

const PLAY_SVG = `<svg class="tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2" aria-hidden="true" width="45" height="56" viewBox="0 0 45 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M43.453 26.325C44.6754 27.1126 44.6754 28.9 43.453 29.6875L3.21759 55.6108C1.88667 56.4683 0.134374 55.5128 0.134374 53.9295L0.134376 2.08302C0.134376 0.499772 1.88667 -0.455747 3.21759 0.401753L43.453 26.325Z" fill="white" fill-opacity="0.5"/>
</svg>
`

export default component((node) => {
  const posterSrc = node.dataset.poster
  const video = node.querySelector('video')
  if (!posterSrc || !video) return

  const button = document.createElement('button')
  const img = document.createElement('img')
  const BUTTON_CLASSES = ['tw-absolute', 'tw-w-full', 'tw-h-full', 'tw-p-0']
  const IMAGE_CLASSES = ['tw-w-full', 'tw-object-cover', 'tw-h-full']

  button.classList.add(...BUTTON_CLASSES)
  button.setAttribute('aria-label', 'play video')
  img.src = posterSrc
  img.alt = ''
  img.classList.add(...IMAGE_CLASSES)

  button.innerHTML = PLAY_SVG
  button.appendChild(img)
  node.appendChild(button)

  const playVideo = (e) => {
    video.play()
    video.focus()
  }

  const toggleOverlay = () => {
    button.classList.toggle('tw-hidden')
  }

  button.addEventListener('click', playVideo)
  video.addEventListener('play', toggleOverlay)
  video.addEventListener('pause', toggleOverlay)

  return () => {
    button.removeEventListener('click', playVideo)
    video.removeEventListener('play', toggleOverlay)
    video.removeEventListener('pause', toggleOverlay)
  }
})
